import { useAudio } from "../contexts/AudioContext";
import AudioIcon from "./AudioIcon";
import DownloadIcon from "./DownloadIcon";
import YoutubeGreyLogo from "@/components/icons/YouTubeGreyLogo";

export default function PublicationDate() {
  const { togglePlayPause } = useAudio();
  return <div className="flex items-center font-mono text-[11px] text-transform-uppercase mb-[-4.4rem] mt-[50px]"> <span className="opacity-50">Published April 3rd 2025</span>
    <VerticalDivider /> <a target="_blank" href="/ai-2027.pdf" className="flex items-center no-underline opacity-50 hover:opacity-100"> <DownloadIcon /> <span className="ml-2">PDF</span> </a>
    <VerticalDivider /> <span onClick={togglePlayPause} className="cursor-pointer flex items-center opacity-50 hover:opacity-100"> <AudioIcon /> <span className="ml-2">Listen</span></span>
    <VerticalDivider /> <a target="_blank" href="https://www.youtube.com/watch?v=5KVDDfAkRgc" className="flex items-center no-underline opacity-50 hover:opacity-100"> <YoutubeGreyLogo /> <span className="ml-2">Watch</span></a>
  </div>
}

const VerticalDivider = () => (
  <div className="w-[1px] h-[11px] bg-black mx-2 opacity-50" />
);
